<template>
  <div class="page">
    <mt-header :title="title" fixed>
      <mt-button icon="back" slot="left" @click.native="$router.back()"></mt-button>
    </mt-header>
    <KoVue v-if="language === 'ko'" />
    <JaVue v-else-if="language === 'ja'" />
    <EnVue v-else />
  </div>
</template>

<script>
import KoVue from './component/ko'
import JaVue from './component/ja'
import EnVue from './component/en'
import { mapState } from 'vuex'
export default {
  components: {KoVue, JaVue, EnVue},
  computed: {
    ...mapState({
      language: ({language}) => language
    }),
    title() {
      const titles = {
        jp: '利用規約',
        ko: '이용약관',
        other: 'Terms and Conditions'
      }
      return titles[this.language] || titles['other']
    }
  }
}
</script>

<style scoped>
/deep/.content {
  padding: 60px 20px 20px;
  font-size: 14px;
  height: 100vh;
  overflow-y: auto;
  box-sizing: border-box;
}
</style>
